import { backendApi } from '../backendApi';

export const documentsApi = {
  downloadDocument: (documentId: string) =>
    backendApi.get(`/api/v1/documents/${documentId}/download`, {
      responseType: 'blob',
    }).then((res) => res.data),
}
